import { gql } from '$lib/apollo';

export const FOLLOW_GAME = gql`
  mutation FollowGame($input: GameFollowCreateInput!) {
    gameFollowCreate(input: $input) {
      result {
        id
        slug
        isFollowing
      }
    }
  }
`;

export const ACCOUNT_COMMUNITIES_EDIT = gql`
  mutation AccountCommunitiesEdit($input: AccountCommunitiesEditInput!) {
    accountCommunitiesEdit(input: $input) {
      result {
        id
      }
    }
  }
`;

export const UNFOLLOW_GAME = gql`
  mutation UnfollowGame($input: GameFollowDeleteInput!) {
    gameFollowDelete(input: $input) {
      result {
        id
        slug
        isFollowing
      }
    }
  }
`;
